import { Component, HostListener, ChangeDetectionStrategy, OnDestroy, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { debounceTime, filter } from 'rxjs';
import { localStorageService } from '../services/localstorage.service';
import { SidemenuComponent } from './sidemenu/sidemenu.component';
import { LayoutHeaderComponent } from './layout-header/layout-header.component';
import { NgClass } from '@angular/common';
import { NotificationsComponent } from '../pages/components/notifications/notifications.component';
import { FmTerminalSocket } from '../pages/components/fm-terminal/fm-terminal.socket';
import { TerminalHandoffService } from '../pages/components/fm-terminal/terminal-handoff.service';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrl: './layout.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SidemenuComponent, LayoutHeaderComponent, NgClass, RouterOutlet, NotificationsComponent]
})
export class LayoutComponent implements OnDestroy {

  /* Held for as long as the panel is open, not only while a terminal screen is.
     The readers use it to answer "is anyone at the panel" — an order can only
     ever come from here, so a till whose business has nobody signed in should be
     able to say so rather than waiting on an order that cannot arrive. The
     terminal screens connect too; the service counts users and keeps one
     connection. */
  private readonly terminalSocket = inject(FmTerminalSocket);
  /* Injected here so it is listening for a reload or a closed tab on every page,
     and so a session the last load of this tab left on a reader is taken back. */
  private readonly terminalHandoff = inject(TerminalHandoffService);

  private hideSideMenuUrls: string[] = ['payment-plans','start-recovery','-debt-recovery', 'hipaa'];
  private hideMainHeaderUrls: string[] = ['payment-plans', 'finance-customer', 'proposals/details', 'contracts/details', 'start-recovery', '-debt-recovery', 'recovery-details', 'hippa', 'debt-recovery/contract-details/', 'disputes/details', 'claims/claim-details/', 'hipaa', 'pay-overtime', 'subscription/members/', 'subscription/proposals/', 'subscription/plans/', 'terminal/rewards', 'terminal/pair', 'terminal/device', 'terminal/support', 'terminal/order'];
  showSideMenu: boolean = true;
  showMainHeader: boolean = true;
  user_profile: any;
  constructor(private _router: Router,
    private _local: localStorageService
  ) { }


  ngOnInit(): void {
    this.terminalSocket.connect();
    this.terminalHandoff.recoverOrphans();
    this.user_profile = this._local.customGetItem('userProfileData');
    this._router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.updateUI(event.url);
      }
    });

    // Check the initial URL on component initialization
    this.updateUI(this._router.url);
  }

  /* Signing out or closing the panel is what takes the business offline for its
     readers. */
  ngOnDestroy(): void {
    this.terminalSocket.release();
  }

  private updateUI(url: string): void {

    this.showSideMenu = !this.hideSideMenuUrls.some(route => url.includes(route));


    this.showMainHeader = !this.hideMainHeaderUrls.some(route => url.includes(route));
  }
}
